import React from 'react';

import { DialogFullScreen as EncoreDialogFullScreen } from '@spotify-internal/encore-creator-web';

import { ResetLightTheme } from './ResetLightTheme';

export function DialogFullScreen(
  props: React.ComponentProps<typeof EncoreDialogFullScreen>,
) {
  return (
    <ResetLightTheme>
      <EncoreDialogFullScreen
        onClose={props.onClose}
        onEscape={props.onEscape}
        navStepper={props.navStepper}
        dialogTitle={props.dialogTitle}
        bodyTitle={props.bodyTitle}
        body={props.body}
        footer={props.footer}
      />
    </ResetLightTheme>
  );
}
